import api from './axiosConfig';

export const servicesAPI = {
  getAll: async (params = {}) => {
    const response = await api.get('/services', { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/services/${id}`);
    return response.data;
  },
  
  create: async (data) => {
    const response = await api.post('/services', data);
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await api.put(`/services/${id}`, data);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/services/${id}`);
    return response.data;
  },

  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/services/upload-image', formData);
    return response.data;
  },

  /** MP4/WebM/etc. for Video Editing portfolio / hero — server limit 500MB; configure proxy if needed */
  uploadVideo: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/services/upload-video', formData);
    const d = response.data;
    const url = typeof d?.url === 'string' ? d.url : (d?.data?.url || '');
    return { ...d, url };
  },
};
